// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tc-container[data-v-68f2fc92]{max-width:1320px;padding-left:16px;padding-right:16px}@media (min-width:775px){.tc-container[data-v-68f2fc92]{padding-left:12.5%;padding-right:12.5%}}", ""]);
// Exports
module.exports = exports;
